export function savedPlaylistFingerprint(playlist, expectedId) {
  const id = String(playlist?.id ?? playlist?.playlistId ?? "");
  if (!id || id !== String(expectedId) || !Number.isSafeInteger(playlist?.version) || playlist.version <= 0 || !Array.isArray(playlist.items))
    throw new Error("The latest saved playlist could not be verified. Reload it before publishing.");
  return JSON.stringify([id, playlist.version, playlist.name, playlist.items]);
}

export function publicationDeliveryText(status) {
  const desired = status?.desiredPublicationVersion, active = status?.activePublicationVersion;
  if (!Number.isSafeInteger(desired) || desired < 0 || !Number.isSafeInteger(active) || active < 0)
    return "Publication installation not reported.";
  if (desired === 0 && active === 0) return "No active publication reported.";
  if (desired > active)
    return active === 0 ? `Publication ${desired} pending; no active publication reported.`
      : `Publication ${desired} pending; device last reported publication ${active} active.`;
  if (desired === active) return `Device last reported publication ${active} active.`;
  return `Device last reported publication ${active}; Cloud desires ${desired}. Refresh status.`;
}
